/**
 * Code copied and modified from github.com/constreo/xlsx-template
 */

function _get_simple(obj, desc) {
    if (desc.indexOf('[') >= 0) {
        const specification = desc.split(/[[[\]]/);
        const property = specification[0];
        const index = specification[1];
        return obj[property][index];
    }

    return obj[desc];
}

function _get(obj, desc, defaultValue) {
    const arr = desc.split('.');
    try {
        while (arr.length) {
            obj = _get_simple(obj, arr.shift());
        }
    } catch (ex) {
        /* invalid chain */
        obj = undefined;
    }
    return obj === undefined ? defaultValue : obj;
}

export const fix = (template) => {
    template.substituteTable = function (row, newTableRows, cells, cell, namedTables, substitution, key, placeholder, drawing) {
        let newCellsInserted = 0; // on the original row
        const mergeCell = this.sheet.root.findall("mergeCells/mergeCell").find(c => this.splitRange(c.attrib.ref).start === cell.attrib.r);
        // if no elements, blank the cell, but don't delete it
        if (substitution.length === 0) {
            delete cell.attrib.t;
            this.replaceChildren(cell, []);
        } else {
            const parentTables = namedTables.filter((namedTable) => {
                const range = this.splitRange(namedTable.root.attrib.ref);
                return this.isWithin(cell.attrib.r, range.start, range.end);
            });

            substitution.forEach((element, idx) => {
                let newRow;
                let newCell;
                let newCellsInsertedOnNewRow = 0;
                const newCells = [];
                const value = _get(element, key, '');

                if (idx === 0) {
                    // insert in the row where the placeholders are

                    if (value instanceof Array) {
                        newCellsInserted = this.substituteArray(cells, cell, value);
                    } else if (placeholder.subType === 'image' && value !== '') {
                        this.substituteImage(cell, placeholder.placeholder, placeholder, value, drawing);
                    } else {
                        this.insertCellValue(cell, value);
                    }
                } else {
                    // insert new rows (or reuse rows just inserted)

                    // Do we have an existing row to use? If not, create one.
                    if (idx - 1 < newTableRows.length) {
                        newRow = newTableRows[idx - 1];
                    } else {
                        newRow = this.cloneElement(row, false);
                        newRow.attrib.r = this.getCurrentRow(row, newTableRows.length + 1).toString();
                        newTableRows.push(newRow);
                    }

                    // Create a new cell
                    newCell = this.cloneElement(cell, true);
                    newCell.attrib.r = this.joinRef({
                        row: parseInt(newRow.attrib.r, 10),
                        col: this.splitRef(newCell.attrib.r).col,
                    });

                    if (value instanceof Array) {
                        newCellsInsertedOnNewRow = this.substituteArray(newCells, newCell, value);

                        // Add each of the new cells created by substituteArray()
                        newCells.forEach((c) => {
                            newRow.append(c);
                        });

                        this.updateRowSpan(newRow, newCellsInsertedOnNewRow);
                    } else if (placeholder.subType === 'image' && value !== '') {
                        // override fit to cell logic, since merge cells are only updated after images are replaced
                        let imageDimensions;
                        if (this.isMergeCell(cell)) {
                            imageDimensions = this.getMergeCellDimensions(cell);
                        }
                        this.substituteImage(newCell, placeholder.placeholder, placeholder, value, drawing, imageDimensions);
                        newRow.append(newCell);
                    } else {
                        this.insertCellValue(newCell, value);
                        newRow.append(newCell);

                        if (mergeCell) {
                            const mergeRange = this.splitRange(mergeCell.attrib.ref);
                            const mergeStart = this.splitRef(mergeRange.start);
                            const mergeEnd = this.splitRef(mergeRange.end);
                            for (let colNum = this.charToNum(mergeStart.col) + 1; colNum <= this.charToNum(mergeEnd.col); colNum++) {
                                const lastRow = this.sheet.root.find('sheetData').getItem(mergeStart.row - 1);
                                const upperCell = lastRow.getItem(colNum - 1);
                                const cell = this.cloneElement(upperCell);
                                cell.attrib.r = this.joinRef({
                                    row: newRow.attrib.r,
                                    col: this.numToChar(colNum)
                                });
                                newRow.append(cell);
                            }
                        }
                    }

                    // expand named table range if necessary
                    parentTables.forEach((namedTable) => {
                        const tableRoot = namedTable.root;
                        const autoFilter = tableRoot.find('autoFilter');
                        const range = this.splitRange(tableRoot.attrib.ref);

                        if (!this.isWithin(newCell.attrib.r, range.start, range.end)) {
                            range.end = this.nextRow(range.end);
                            tableRoot.attrib.ref = this.joinRange(range);
                            if (autoFilter !== null) {
                                // XXX: This is a simplification that may stomp on some configurations
                                autoFilter.attrib.ref = tableRoot.attrib.ref;
                            }
                        }
                    });
                }
            });
        }
        return newCellsInserted;
    };
}